<template>
  <v-layout row justify-center>
    <v-dialog v-model="displayForm" persistent max-width="980px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title>
            <span class="headline">Update Product's set</span>
          </v-card-title>
          <div class="text-xs-center">
            <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
          </div>
          <v-card-text v-if="!loading">
            <v-alert
              :value="message"
              type="error"
              dismissible
              transition="scale-transition"
            >{{ message }}</v-alert>

            <v-container grid-list-md>
              <v-card>
                <v-card-text>
                  <h2 class="subheading">Search a set exists</h2>
                  <p>
                    <product-set-search
                      :initialSearch="item ? item.name : ''"
                      v-on:select-set="associateSet($event)"
                    ></product-set-search>
                  </p>
                  <h2 class="subheading">Or</h2>
                  <v-btn @click="createDialog = !createDialog">Create a new Set</v-btn>
                  <h2 class="subheading">Or</h2>
                  <v-btn @click="removeSet()">Remove from set</v-btn>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="cancel()" :disabled="loading">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="update()" :disabled="loading">Update</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="createDialog" persistent max-width="980px">
      <v-card>
        <v-toolbar color="secondary" dark>
          <v-toolbar-title>Create a new set</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items class="hidden-sm-and-down">
            <v-btn text @click="createDialog = !createDialog">Close</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs6>
                  <v-text-field v-model="newSet.name" label="Name" :rules="mandatoryRules"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="newSet.classification"
                    label="Classification"
                    :rules="mandatoryRules"
                    :items="classifications"
                    :loading="classificationLoading"
                  ></v-select>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="newSet.dominantHand"
                    label="Dominant Hand"
                    :items="dominantHand"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-btn @click="createSet()">Create</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ProductSetSearch from "@components/products/ProductSetSearch.vue";
function getDefaultData() {
  return {
    newSet: {
      name: null,
      classification: null,
      dominantHand: null
    },
    model: {},
    valid: null,
    mandatoryRules: [v => !!v || "This fiels is mandatory"],
    types: [
      { value: "shipping", text: "Shipping Address" },
      { value: "billing", text: "Billing Address" }
    ],
    message: null,
    createDialog: false,
    classifications: [],
    classificationLoading: false,
    dominantHand: [
      { value: "", text: "Any" },
      { value: "rh", text: "Right Hand" },
      { value: "lh", text: "Left Hand" }
    ]
  };
}
export default {
  components: {
    ProductSetSearch
  },
  props: ["item", "open", "productId"],
  data: getDefaultData,
  computed: {
    displayForm: function() {
      return this.open;
    },
    loading: function() {
      return this.$store.getters["clientAddresses/loading"];
    }
  },
  watch: {
    item: function(newVal) {
      // watch it
      Object.assign(this.model, newVal);
    }
  },
  mounted: function() {
    this.getProductTypes();
  },
  methods: {
    getProductTypes() {
      this.classificationLoading = true;
      this.$store
        .dispatch("products/getProductTypes")
        .then(data => {
          this.classifications = data.types;
        })
        .finally(() => (this.classificationLoading = false));
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    },

    associateSet: function(event) {
      this.$store
        .dispatch("products/updateSet", {
          setId: event.id,
          productId: this.productId
        })
        .then(() => {
          this.$emit("associated");
        });
    },
    removeSet: function() {
      this.$store
        .dispatch("products/updateSet", {
          setId: 0,
          productId: this.productId
        })
        .then(() => {
          this.$emit("associated");
        });
    },
    createSet: function() {
      this.$store
        .dispatch("productSets/create", {
          model: this.newSet
        })
        .then(data => {
          this.associateSet(data);
          this.createDialog = false;
        });
    }
  }
};
</script>

<style></style>
